<template>
	<layout>
		<template slot="left">
			<publicMenu :list="list" iconUrl="list"></publicMenu>
		</template>
		<template slot="right">
			<router-view></router-view>

			<!-- <keep-alive>
				
			</keep-alive> -->

		</template>
	</layout>
</template>

<script>
import layout from "../../components/layout.vue"
import detail from './component/detail.vue';
import publicMenu from "../../components/publicMenu.vue"
export default {
	components: {
		layout,
		detail,
		publicMenu
	},
	data() {
		return {
			leftTreeData: [], //左侧树数据
			formData: [],
			list: []
		};
	},
	methods: {
		getRow(obj, fuObj) {
			console.log(obj)
			console.log(fuObj);
			this.$router.push(`/index/member/administrator/${obj.label}/${fuObj.data.id}`)
			// 			if (fuObj.level == 3) {


			// 			}
			// 			if (fuObj.level == 2 && fuObj.childNodes.length==0) {
			// 				this.$router.push(`/index/member/administrator/${obj.name}/${obj.id}`)
			// 				return

			// 			}
			// 			if(obj.label=='商户'){
			// 				this.$router.push("/index/member/merchant")
			// 				return
			// 			}
			// 			if(obj.label=='第三方服务人员'){
			// 				this.$router.push("/index/member/servicePersonal")
			// 				return
			// 			}
		},
		getAll() {
			this.$http.get(`/api/system/dept/treeselect2`).then(res => {
				console.log(res.data.data)
				// res.data.data.filter(item => {
				// 	return item.name == "业主"
				// })[0].children.forEach(item => {
				// 	item.bdDepts = [{
				// 		name: "管理员"
				// 	}, {
				// 		name: "人才"
				// 	}]
				// })
				this.leftTreeData = res.data.data
				this.$router.push(`/index/member/administrator/${'江苏国际人才公寓'}/${100}`)
				// this.getRow("江苏国际人才公寓",100)
			})
		}
	},
	mounted() {
		var a = JSON.parse(localStorage.getItem("cd"))
		a.forEach(val => {
			if (val.meta.title == '成员') {
				var b = val.children
				this.list = this.list.concat(b)
			}
		})
		if (this.$route.path == '/index/member') {
			this.$router.push(this.list[0].children[0].path)
		}
		return
		this.getAll();
	}
};
</script>

<style scoped="scoped">
>>>.el-tree-node__content:hover {
	background-color: #00A790
}
</style>
